import React, { useEffect, useState } from "react";
import hero1 from "../images/hero_1.jpg";
import axios from "../axios/axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import CompanyCard from "../component/CompanyCard";

function AppliedUsers() {
  const [jobs, setJobs] = useState([]);
  const { userInfo } = useSelector((state) => state.signIn);
  console.log(userInfo);
  const getJobs = async () => {
    try {
      const { data } = await axios.get(
        `/api/company/jobs/${userInfo.user._id}`
      );
      console.log(data);
      setJobs(data);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getJobs();
  }, []);
  return (
    <>
      <section
        className="section-hero overlay inner-page bg-image"
        style={{ backgroundImage: `url(${hero1})` }}
        id="home-section"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-7 mt-5">
              <h3 className="text-white ">Jobs Created For Meta</h3>
              <Link to="/" style={{ color: "white" }}>
                Home
              </Link>{" "}
              <span className="mx-2 slash">/</span>
              <Link to="/" style={{ color: "white" }}>
                Company
              </Link>{" "}
              <span className="mx-2 slash">/</span>
              <span className="text-white">
                <strong>Company Jobs</strong>
              </span>
            </div>
          </div>
        </div>
      </section>
      {jobs?.length === 0 ? (
        <h1 style={{ textAlign: "center", marginTop: "20px" }}>No Jobs Yet!</h1>
      ) : (
        <>
          <h2 style={{ textAlign: "center", marginTop: "20px" }}>
            Jobs Posted
          </h2>
          <div className="CompanyJobs">
            {jobs?.map((job, i) => (
              <CompanyCard
              getJobs={getJobs}
                key={i}
                ownerid={job._id}
                jobType={job.jobType}
                position={job.position}
                minSalary={job.minSalary}
                maxSalary={job.maxSalary}
                location={job.jobLocation}
                logo={job.jobLogo}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
}
export default AppliedUsers;
